import { tableHeader } from './TableHeader.css';
import type { TPostTableHeaderProps } from './TableHeader.types';

export { tableHeader as postTableHeaderClass } from './TableHeader.css';

export const PostTableHeader = (props: TPostTableHeaderProps) => {
  const { children } = props;

  return <th className={tableHeader}>{children}</th>;
};
